import { useEffect, useState } from 'react';

export const usePageLoad = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const onPageLoad = () => {
      setLoaded(true);
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
    }

    return () => window.removeEventListener('load', onPageLoad);
  }, []);

  return loaded;
};
